import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormControl, FormGroup, InputGroup, Button, DropdownButton, MenuItem } from 'react-bootstrap'
import { tableHelper, momentHelper } from './helpers'
import ReportStore from '../../stores/ReportStore'
import IframeModal from '../../component/element/IframeModal'
import FontAwesome from 'react-fontawesome';
import Select from 'react-select';
import './report.css'
import Chart from 'chart.js';
import { findDOMNode } from 'react-dom'
import withSizes from 'react-sizes';

const keyYear = ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec']
const optionsRows = [10,20,50,100]
const optionsYear = []
for (var i = momentHelper.getYear(); i >= 2557; i--) {
  optionsYear.push({
    value: i,
    label: i
  });
}

class ReportKKCAllYearProfit extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loadling: false,
      year: momentHelper.getYear(),
      data2: {
            income:[{list:'INCOME',month:[{label:'jan',value:100},{label:'feb',value:200},{label:'mar',value:300},{label:'apr',value:400},{label:'may',value:500},{label:'jun',value:600},{label:'jul',value:700},{label:'aug',value:800},{label:'sep',value:900},{label:'oct',value:1000},{label:'nov',value:1100},{label:'dec',value:1200}]},{list:'xxx',month:[{label:'jan',value:3333},{label:'feb',value:2222},{label:'mar',value:1111},{label:'apr',value:999},{label:'may',value:888},{label:'jun',value:777},{label:'jul',value:666},{label:'aug',value:555},{label:'sep',value:444},{label:'oct',value:333},{label:'nov',value:222},{label:'dec',value:111}]}],
            poe:[{list:'POE',month:[{label:'jan',value:100},{label:'feb',value:200},{label:'mar',value:300},{label:'apr',value:400},{label:'may',value:500},{label:'jun',value:600},{label:'jul',value:700},{label:'aug',value:800},{label:'sep',value:900},{label:'oct',value:1000},{label:'nov',value:1100},{label:'dec',value:1200}]},{list:'xxx',month:[{label:'jan',value:100},{label:'feb',value:200},{label:'mar',value:300},{label:'apr',value:400},{label:'may',value:500},{label:'jun',value:600},{label:'jul',value:700},{label:'aug',value:800},{label:'sep',value:900},{label:'oct',value:1000},{label:'nov',value:1100},{label:'dec',value:1200}]}],
            profit:[{list:'PROFIT',month:[{label:'jan',value:100},{label:'feb',value:200},{label:'mar',value:300},{label:'apr',value:400},{label:'may',value:500},{label:'jun',value:600},{label:'jul',value:700},{label:'aug',value:800},{label:'sep',value:900},{label:'oct',value:1000},{label:'nov',value:1100},{label:'dec',value:1200}]},{list:'xxx',month:[{label:'jan',value:100},{label:'feb',value:200},{label:'mar',value:300},{label:'apr',value:400},{label:'may',value:500},{label:'jun',value:600},{label:'jul',value:700},{label:'aug',value:800},{label:'sep',value:900},{label:'oct',value:1000},{label:'nov',value:1100},{label:'dec',value:1200}]}]
      },
      data: {
        company:{company_name:''},income:[],total_income:[],total_expense:[],balance:[],balance_work:[],poe:[],work:[],affiliate:[],profit:[]
      },      
      btnBar: (<div><FontAwesome name='bar-chart'/>&nbsp;ดูกราฟแท่ง</div>),  
      btnAction: 'barchart',
      displayTb: '',
      displayBar: 'none'
    }
    this.barChart = null
  }

  componentDidMount(){
    if (this.props.showPrintPreview)
      this.loadData(this.props.year)
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.year)
    }
  }

  loadData(year=''){
    this.setState({loading:true})
    ReportStore.loadReportAllYearProfit(year,(result)=>{
      this.setState({data:result.data,loading:false})   
      this.setBarChart()   
    })
  }

  onPrintClick(e) {
    let type_print = 'report'
    if (this.state.displayBar==='')
      type_print = 'chart'

    let year = this.state.year - 543
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintReportKKCAllYearProfit&year='+year+'&type_print='+type_print
    } else{
      url = './pdf/v2/?startPage=PrintReportKKCAllYearProfit&year='+year+'&type_print='+type_print
    }
    this.refs.iframe.loadUrl(url)
  }

  onYearChange(e) {
    this.setState({year:e.value})
    this.loadData(e.value)
  }

  onRowsPerPageChange(e) {

  }

  handleSelect(e) {

  }

  onBarChartClick(action,e) {
    let {displayTb,displayBar,btnBar,btnAction,year} = this.state
    let new_action = ''
    if (action=="barchart") {
      new_action = "report"
      this.setState({btnAction:new_action,displayTb:'none',displayBar:'',btnBar:(<div><FontAwesome name='file-text'/>&nbsp;ดูรายงาน</div>)})
      this.loadData(year)
      this.setBarChart()  
    } else {
      new_action = "barchart"
      this.setState({btnAction:new_action,displayTb:'',displayBar:'none',btnBar:(<div><FontAwesome name='bar-chart'/>&nbsp;ดูกราฟแท่ง</div>)})
      this.loadData(year)
    }
  }

  setBarChart() { 
    this.canvasBar = findDOMNode(this.canvasBarRef);
    this.ctxBar = this.canvasBar.getContext('2d');
    let canvasBar = this.canvasBar,ctxBar=this.ctxBar 

    let {data} = this.state
    let keyGet = [1,2,3,4,5,6,7,8,9,10,11,12]
    let aff = []
    let income = []
    let poe = []
    keyGet.forEach(function(key,_index) {
      let sum = 0
      data.affiliate.forEach(function(item,index) {
        let value = (item[key]===''||item[key]===null||item[key]===undefined||isNaN(item[key])?0:item[key])
        sum += parseFloat(value)
      })
      aff.push(sum)
    })
    keyGet.forEach(function(key,_index) {
      let sum = 0
      data.income.forEach(function(item,index) {
        let value = (item[key]===''||item[key]===null||item[key]===undefined||isNaN(item[key])?0:item[key])
        sum += parseFloat(value)
      })
      income.push(sum)
    })
    keyGet.forEach(function(key,_index) {
      let sum = 0
      data.poe.forEach(function(item,index) {
        let value = (item[key]===''||item[key]===null||item[key]===undefined||isNaN(item[key])?0:item[key])
        sum += parseFloat(value)
      })
      poe.push(sum)
    })  

    let labels = ['มค.','กพ.','มีค.','เมย.','พค.','มิย.','กค.','สค.','กย.','ตค.','พย.','ธค.']
    let datasets = [
      {backgroundColor:'green',data:income,label:'รวมรายรับเงินสดและเงินโอนจากลูกค้า'},
      {backgroundColor:'red',data:poe,label:'รวมรายจ่ายทั้งสิ้น'},
      {backgroundColor:'blue',data:aff,label:'รวมรายรับจากการซ่อมรถในเครือ'}
    ]

    if(this.barChart!=null)
      this.barChart.destroy()

    this.barChart = new Chart(ctxBar, {
      type: 'bar',
      data: {
          labels: labels,
          datasets: datasets
      },
      options: {
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero:true
                }
            }]
        }
      }
    })
  }

  renderToolbar() {
    return(
      <Form inline style={{marginBottom:'5px'}}>
        <FormGroup>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.year}
            options={optionsYear}
            style={{width:"80px"}}
            onChange={this.onYearChange.bind(this)}
          />
        </FormGroup>  
        {' '}
        <FormGroup>
          <Button
            className='btn-primary'
            onClick={this.onBarChartClick.bind(this,this.state.btnAction)}
          >
            {this.state.btnBar}
          </Button>
        </FormGroup>
      </Form>
    )
  }

  renderPagination() {
    return(
      <div className="text-right">
        <Form inline>
          <FormGroup>
            จำนวนแถวต่อหน้า
          </FormGroup>  
          {' '}
          <FormGroup>
            <DropdownButton id='select-row-per-page' bsStyle={'default'} title={this.state.defaultRows} onSelect={this.onRowsPerPageChange.bind(this)}>
              {optionsRows.map((item,index)=>(
                <MenuItem key={index} eventKey={item}>{item}</MenuItem>  
              ))}
            </DropdownButton>
          </FormGroup> 
          {' '} 
          <FormGroup style={{lineHeight:'10px'}}>
            <Pagination
              prev={'ก่อนหน้า'}
              next={'ถัดไป'}
              first={false}
              last={false}
              ellipsis
              boundaryLinks
              items={this.state.totalPage}
              maxButtons={5}
              activePage={this.state.activePage}
              onSelect={this.handleSelect.bind(this)}
            />
          </FormGroup>  
        </Form>  
      </div>
    )
  }

  renderRowTitle(text) {
    return(
            <tr>
              <td colSpan={2} className='text-center'>{text}</td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-right'></td>
            </tr>
    )
  }

  renderRowData(key) {
    let {data} = this.state

    if (data.length===0||data===undefined) {
      return(<tr><td colSpan={15}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data[key].map((item,index) => {
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td>{item.name}</td>
              {this.renderColMonth(item)}
              <td className='text-right'>{this.getNumberFormat(item.sum_amount)}</td>
            </tr>
          )
        })
      )
    }
  }

  renderColMonth(data) {
    return new Array(12).fill('').map((item,index)=>(
      <td key={index} className='text-right' style={{minWidth:'80px'}}>
        {this.getNumberFormat(data[index+1])}
      </td>
    ))
    return(
      data.map((item,index) => {
        return(
          <td key={index} className='text-right' style={{minWidth:'80px'}}>
            {item.value}
          </td>
        )
      })
    )
  }

  renderSummary(text,key='') {
    return(
      <tr>
        <th colSpan={2} className='text-center'>{text}</th>
        <th className='text-right'>{this.getColSummary(key,'1')}</th>
        <th className='text-right'>{this.getColSummary(key,'2')}</th>
        <th className='text-right'>{this.getColSummary(key,'3')}</th>
        <th className='text-right'>{this.getColSummary(key,'4')}</th>
        <th className='text-right'>{this.getColSummary(key,'5')}</th>
        <th className='text-right'>{this.getColSummary(key,'6')}</th>
        <th className='text-right'>{this.getColSummary(key,'7')}</th>
        <th className='text-right'>{this.getColSummary(key,'8')}</th>
        <th className='text-right'>{this.getColSummary(key,'9')}</th>
        <th className='text-right'>{this.getColSummary(key,'10')}</th>
        <th className='text-right'>{this.getColSummary(key,'11')}</th>
        <th className='text-right'>{this.getColSummary(key,'12')}</th>
        <th className='text-right'>{this.getColSummary(key,'sum_amount')}</th>
      </tr>
    )
  }

  getRowSummary(key) {
    let sum = 0
    sum = parseFloat(this.getColSummary(key,'jan')) + parseFloat(this.getColSummary(key,'feb')) + parseFloat(this.getColSummary(key,'mar')) + parseFloat(this.getColSummary(key,'apr')) + parseFloat(this.getColSummary(key,'may')) + parseFloat(this.getColSummary(key,'jun')) + parseFloat(this.getColSummary(key,'jul')) + parseFloat(this.getColSummary(key,'aug')) + parseFloat(this.getColSummary(key,'sep')) + parseFloat(this.getColSummary(key,'oct')) + parseFloat(this.getColSummary(key,'nov')) + parseFloat(this.getColSummary(key,'dec'))
    return this.getNumberFormat(sum)
  }  

  getRowValue(key,row) {
    let {data} = this.state
    let sum = 0
    data[key].forEach(function(items,indexs) {
      items.month.forEach(function(item,index) {
        if (indexs===row)
          sum += parseFloat(item.value)
      })
    })
    return sum
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)    
    if(_val===0){
      return ''
    }
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getColSummary(key,month) {
    let {data} = this.state
    let sum = 0
    
    data[key].forEach(function(item,index) {
      sum += item[month]*1
    })
    return this.getNumberFormat(sum)
  }

  renderTable() {
    let {company} = this.state.data
    return(
      <div className="display-overflow">
        <table className="table table-responsive table-bordered-solid table-hover" style={{minWidth:'1800px'}}>
          <thead>
            <tr>
              <th colSpan={15} className='text-center'>สรุปรายรับ - รายจ่ายประจำปี {this.state.year}</th>
            </tr>
            <tr>
              <th rowSpan={2} className='text-center' style={{width:'50px'}}>ลำดับ</th>
              <th rowSpan={2} className='text-center' style={{width:'300px'}}>รายชื่อลูกค้า</th>
              <th colSpan={12} className='text-center'>รายรับ - รายจ่าย (จ่ายจริง) ของ {company.company_name} ประจำปี {this.state.year}</th>
              <th rowSpan={2} className='text-center' style={{width:'200px'}}>รวม</th>
            </tr>
            <tr>
              <th className='text-center' style={{width:'100px'}}>มค.</th>
              <th className='text-center' style={{width:'100px'}}>กพ.</th>
              <th className='text-center' style={{width:'100px'}}>มีค.</th>
              <th className='text-center' style={{width:'100px'}}>เมย.</th>
              <th className='text-center' style={{width:'100px'}}>พค.</th>
              <th className='text-center' style={{width:'100px'}}>มิย.</th>
              <th className='text-center' style={{width:'100px'}}>กค.</th>
              <th className='text-center' style={{width:'100px'}}>สค.</th>
              <th className='text-center' style={{width:'100px'}}>กย.</th>
              <th className='text-center' style={{width:'100px'}}>ตค.</th>
              <th className='text-center' style={{width:'100px'}}>พย.</th>
              <th className='text-center' style={{width:'100px'}}>ธค.</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowTitle('รายรับ (ยอดเงินหลังหักภาษี ณ ที่จ่าย 3%)')}
            {this.renderRowData('income')}
          </tbody>
          <thead>
            {this.renderSummary('รวมรายรับเงินสดและเงินโอนจากลูกค้า','total_income')}
            {this.renderSummary('รายได้จากรถเข้าซ่อมของเดือน มค. - ธค.','work')}
          </thead>
          <tbody>
            {this.renderRowTitle('รายจ่าย')}
            {this.renderRowData('poe')}
          </tbody>  
          <thead>
            {this.renderSummary('รวมรายจ่ายทั้งสิ้น','total_expense')}
            {this.renderSummary('รายได้เงินสดคงเหลือ','balance')}
            {this.renderSummary('รายได้จากการเข้าซ่อม คงเหลือสุทธิ','balance_work')}
          </thead>
          <tbody>
            {this.renderRowTitle('รายได้จากการซ่อมรถในเครือ')}
            {this.renderRowData('affiliate')}
          </tbody>
          <thead>
            {this.renderSummary('รวมรายรับจากการซ่อมรถในเครือ','affiliate')}
            {this.renderSummary('รวมรายรับสุทธิเหลือในแต่ละเดือน','profit')}
          </thead>
        </table>
      </div>
    )
  }

  renderBarChat() {
    return(
      <div>
        <canvas 
          ref={(canvasBar) => { this.canvasBarRef = canvasBar; }}>
        </canvas>
      </div>
    )
  }

  render() {
    let {data} = this.state
    let {isMobile} = this.props
    if (this.props.showPrintPreview) { 
      if (this.props.typePrint==='chart') {
        if (data.income.length===0&&data.poe.length===0&&data.affiliate.length===0) {
          return(
            <div className='font-print'>
              <header className="text-center">
                <h2>ไม่พบข้อมูล</h2>
              </header>
            </div>
          )
        } else {
          return(
            <div className='font-print'>
              <header style={{textAlign:'center',marginBottom:'20px'}}>
                <h2>{this.props.titleBarChat}</h2>
              </header>
              <div className='font-14'>   
                {this.renderBarChat()}          
              </div>
            </div>  
          )
        } 
      }
    } else {
      return(
        <div>
          <Box loading={this.state.loading}>
            <Box.Header border={true}>
              <Box.Title>
                {this.props.renderMenu()}
              </Box.Title>
              <div className='box-tools' style={{position:(isMobile?'static':'absolute')}}>
                <Button                 
                  bsStyle={'link'} className='bg-maroon'
                  onClick={this.onPrintClick.bind(this)}
                >
                  <FontAwesome name='print'/>&nbsp;พิมพ์เอกสาร
                </Button>                           
              </div>
            </Box.Header>
              <Box.Body>
                {this.renderToolbar()}
                <div style={{display:this.state.displayTb}}>
                  {this.renderTable()}
                </div> 
                <div style={{display:this.state.displayBar}}>
                  {this.renderBarChat()}
                </div>
                <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
              </Box.Body>
            </Box>
        </div>
      )
    }  
  }
}

ReportKKCAllYearProfit.defaultProps = {
  show : false
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
})

export default ReportKKCAllYearProfit = withSizes(mapSizesToProps)(ReportKKCAllYearProfit);


// WEBPACK FOOTER //
// ./src/view/report/ReportKKCAllYearProfit.js